import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/impressum',
    name: 'Impressum',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Impressum.vue')
  },

  {
    path: '/end',
    name: 'End',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/End.vue')
  },
  {
    path: '/mapbox',
    name: 'Mapbox',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Mapbox.vue')
  },
  {
    path: '/waypointsTest',
    name: 'WaypointsTest',
    component: () => import('../views/WaypointsTest.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
